// src/lib/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const url  = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

// One-time diagnostics in dev so you immediately see misconfig
if (typeof window !== 'undefined' && !window.__SUPA_DIAG__) {
  window.__SUPA_DIAG__ = true;
  if (!url)  console.error('[Supabase] Missing REACT_APP_SUPABASE_URL');
  if (!anon) console.error('[Supabase] Missing REACT_APP_SUPABASE_ANON_KEY');
  if (url && anon) {
    console.log('[Supabase] Using URL:', url);
    console.log('[Supabase] Anon key last4:',
      String(anon).slice(-4));
  }
}

if (!url) throw new Error('supabaseUrl is required.');
if (!anon) throw new Error('supabaseAnonKey is required.');

export const SUPABASE_URL = url;
export const SUPABASE_ANON_KEY = anon;
export const supabase = createClient(url, anon);
